import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Tooltip from "@material-ui/core/Tooltip";
import CvcIcon from 'web/assets/images/cvc.png';
import Popup from '../Popup';
import * as moment from 'moment';
import { showAppLoader, hideAppLoader } from 'redux/actions/app';

import {
  useStripe,
  useElements,
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
} from '@stripe/react-stripe-js';

import Spinner from 'web/components/Spinner';
import AlertModal from 'web/components/AlertModal';
import { setupIntentGet } from 'redux/actions/register';
import { paymentMethodCreate, subscriptionsCreate, subscriptionsAddNew, paymentMethodProfileCreate, profileCreateBuyerSeller } from 'redux/actions/payment';
import { CardTypeSectionStripe } from 'web/components/AddCardPopup/Credit-Card/debit-form/debit-Form-Styled';
import { getProfileDetails } from 'redux/actions/profile'
import styles from './debitForm.module.scss';

const useOptions = () => {
  const fontSize = '16px';
  const options = useMemo(
    () => ({
      style: {
        base: {
          fontSize,
          color: '#424770',
          letterSpacing: '0.025em',
          fontFamily: 'Source Code Pro, monospace',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
        invalid: {
          color: '#9e2146',
        },
      },
    }),
    [fontSize]
  );

  return options;
};

const DebitForm = ({ individual, type, props, callBackFetchApi, callBackModal, callBack, paymentType, pageLanguageContents }) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const token = localStorage.getItem('token');
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const [cardName, setCardName] = useState('');
  const [alertType, setAlertType] = useState();
  const toggleModal = () => setModal(!modal);
  let title = '';

  const [yesNomodal, setYesNoModal] = useState(false);
  const yesNoToggleModal = () => setYesNoModal(!yesNomodal);
  const loaderVisible = useSelector(
    (state) => state.appReducer.loaderVisible
  );
  const stripe = useStripe();
  const elements = useElements();
  const options = useOptions();

  let cardBrandToPfClass = {
    visa: 'pf-visa',
    mastercard: 'pf-mastercard',
    amex: 'pf-american-express',
    discover: 'pf-discover',
    diners: 'pf-diners',
    jcb: 'pf-jcb',
    unknown: 'pf-credit-card',
  };

  let taxId = localStorage.getItem('taxId')
  let drivingLicense = localStorage.getItem('drivingLicense');

  let companyName = localStorage.getItem('companyName')
  if (!companyName) {
    companyName = ''
  }

  let firstName = localStorage.getItem('firstName');
  let lastName = localStorage.getItem('lastName');
  let dob = localStorage.getItem('dob')
  let uploadImage = localStorage.getItem('uploadImage')

  const setBrandIcon = (brand) => {
    let brandIconElement = document.getElementById('brand-icon0');
    let pfClass = 'pf-credit-card';
    if (brand in cardBrandToPfClass) {
      pfClass = cardBrandToPfClass[brand];
    }
    for (let i = brandIconElement.classList.length - 1; i >= 0; i--) {
      brandIconElement.classList.remove(brandIconElement.classList[i]);
    }
    brandIconElement.classList.add('pf');
    brandIconElement.classList.add(pfClass);
  };

  const profileAPI = async () => {
    let data = { authId: localStorage.getItem('authId') }
    let response = await dispatch(getProfileDetails(token, data));
    if (response.userRole) {
      localStorage.setItem('userName', response.userName)
      if (response.userRole === 'GUEST') {
        localStorage.setItem('accountType', 'Guest');
      } else if (response.userRole === 'BUYSELL') {
        localStorage.setItem('accountType', 'Both');
      } else if (response.userRole === 'BUYER') {
        localStorage.setItem('accountType', 'Buyer');
      } else if (response.userRole === 'SELLER') {
        localStorage.setItem('accountType', 'Seller');
      }
    }
  }

  const profileUpdate = async (result) => {
    let data = {
      forBuying: true,
      paymentMethodId: result.setupIntent.payment_method,
      name: cardName,
      forReseller: true,
    }
    let response = await dispatch(profileCreateBuyerSeller(data, token));
    if (response.status === "SUCCESS") {
      setAlertType('buyerCardValidated')
      setModalContent("Card details added successfully.");
      setModalLink('');
      toggleModal();
    } else {
      if (response.message === "Unauthorized (Invalid token)") {
        history.push('/sign-in');
        window.location.reload(false);
      } else {
        setModalContent(response.message);
        setModalLink('');
        toggleModal();
      }
    }
  }
  const callProfileApI = async () => {
    const getResponse = await dispatch(setupIntentGet(token));
    if (getResponse.status === "SUCCESS") {
      let client_secret = getResponse.payload
      const payload = await stripe
        .confirmCardSetup(client_secret, {
          payment_method: {
            card: elements.getElement(CardNumberElement),
            billing_details: {
              name: cardName,
            },
          },
        })
        .then(function (result) {
          if (result.error) {
            dispatch(hideAppLoader());
            setModalContent(result.error.message);
            setModalLink('');
            toggleModal();
          } else {
            profileUpdate(result)
          }
        });

    } else {
      if (getResponse.message === "Unauthorized (Invalid token)") {
        history.push('/sign-in');
        window.location.reload(false);
      } else {
        setModalContent(getResponse.message);
        setModalLink('');
        toggleModal();
      }
    }
  }
  const callSubmit = async () => {
    if (props) {
      const { setTouched } = props
      setTouched({});
    }

    if ((individual === "profileType" || individual === "Individual") && paymentType === 'Selling') {
      if (props.values.taxIdType === '0' && (!drivingLicense || drivingLicense === 'undefined')) {
        if (taxId) {
          accountTokenApi(props)
        } else {
          setModalContent('Tax Id does not exit. Please enter new Tax Id.')
          setModalLink('');
          toggleModal();
        }
      } else if (props.values.taxIdType === '1') {
        if (props.values.taxId) {
          accountTokenApi(props)
        } else {
          setModalContent('Tax Id is required.')
          setModalLink('');
          toggleModal();
        }
      } else if (drivingLicense && props.values.taxIdType === '0') {
        licenceType(props)
      } else {
        if (props.values.firstName && props.values.lastName && props.values.drivingLicense && props.values.drivingLicenseDoc) {
          if (moment().diff(moment(props.values.dob), 'years') >= 18) {
            licenceType(props)
          } else {
            setModalContent('You are not under 18 years of age.')
            setModalLink('');
            toggleModal();
          }

        } else {
          if (!props.values.drivingLicense) {
            setModalContent('Driving license is required.')
          }
          else if (!props.values.firstName) {
            setModalContent('First name is required.')
          }
          else if (!props.values.lastName) {
            setModalContent('Last name is required.')
          }
          else if (!props.values.drivingLicenseDoc) {
            setModalContent("Please upload driver's license first.");
          }
          setModalLink('');
          toggleModal();
        }
      }
    } else {
      dispatch(showAppLoader())
      addAccount(props, '')
    }

  }
  const licenceType = async (props) => {
    let businessType = ''
    if (localStorage.getItem('location') === 'SUBSIDIARY' && localStorage.getItem('isCentralizedPaymentMethod')) {
      businessType = "individual"
    } else if (drivingLicense) {
      businessType = "individual"
    } else {
      businessType = "company"
    }
    let dayMonthYear = drivingLicense && props.values.taxIdType === '0' ? dob.split('-') : props.values.dob.split('-')
    const result = await stripe.createToken('account', {
      business_type: businessType,
      individual: {
        first_name: drivingLicense && props.values.taxIdType === '0' ? firstName : props.values.firstName,
        last_name: drivingLicense && props.values.taxIdType === '0' ? lastName : props.values.lastName,
        dob: {
          day: dayMonthYear[2],
          month: dayMonthYear[1],
          year: dayMonthYear[0]
        },
        ssn_last_4: '1234',
      },
      tos_shown_and_accepted: true,
    }).then(function (result) {
      if (result.token) {
        addAccount(props, result.token.id)
      }
      if (result.error) {
        setModalContent(result.error.message)
        setModalLink('');
        toggleModal();
        return false
      }
    });

  }
  const accountTokenApi = async (props) => {
    let businessType = ''
    if (localStorage.getItem('location') === 'SUBSIDIARY' && localStorage.getItem('isCentralizedPaymentMethod')) {
      businessType = "individual"
    } else {
      businessType = "company"
    }


    const result = await stripe.createToken('account', {
      business_type: businessType,
      company: {
        tax_id: props.values.taxIdType === '1' ? props.values.taxId : taxId,
        name: companyName
      },
      tos_shown_and_accepted: true,
    }).then(function (result) {
      if (result.token) {
        addAccount(props, result.token.id)
      }
      if (result.error) {
        setModalContent(result.error.message)
        setModalLink('');
        toggleModal();
        return false
      }
    });
  }

  const addAccount = async (props, accountToken) => {
    if (paymentType === 'Selling') {
      const card = elements.getElement(CardNumberElement);
      const result = await stripe.createToken(card, {
        currency: 'usd',
        name: cardName,
      }, stripeResponseHandler);
      if (result.token) {
        if (result.token.card.funding === "debit") {
          dispatch(hideAppLoader());
          let data = {
            forSelling: true,
            token: result.token.id,
            name: cardName,
            forReseller: true,
          }
          let response;
          if (individual === "Individual") {
            let dataVal = {
              forSelling: true,
              token: result.token.id,
              name: cardName,
              forReseller: true,
              accountToken: accountToken,
              drivingLicense: drivingLicense && props.values.taxIdType === '0' ? drivingLicense : props.values.drivingLicense,
              uploadImage: drivingLicense && uploadImage ? uploadImage : props.values.drivingLicenseDoc,
              dob: drivingLicense && props.values.taxIdType === '0' ? dob : props.values.taxIdType === '2' ? props.values.dob : '',
              taxId: props.values.taxIdType === '1' ? props.values.taxId : taxId//,props.values.taxId
            }
            response = await dispatch(paymentMethodProfileCreate(dataVal, token));
          } else {
            if (individual === "profileType") {
              let data = {
                forSelling: true,
                token: result.token.id,
                name: cardName,
                forReseller: true,
                accountToken: accountToken,
                drivingLicense: drivingLicense && props.values.taxIdType === '0' ? drivingLicense : props.values.drivingLicense,
                uploadImage: drivingLicense && uploadImage ? uploadImage : props.values.drivingLicenseDoc,
                dob: drivingLicense && props.values.taxIdType === '0' ? dob : props.values.taxIdType === '2' ? props.values.dob : '',
                taxId: props.values.taxIdType === '1' ? props.values.taxId : taxId
              }
              response = await dispatch(profileCreateBuyerSeller(data, token));
            } else {
              response = await dispatch(paymentMethodCreate(data, token));
            }
          }
          if (response.status === "SUCCESS") {
            setAlertType('cardValidated')
            setModalContent("Card details added successfully.");
            setModalLink('');
            toggleModal();
          } else {
            if (response.message === "Unauthorized (Invalid token)") {
              history.push('/sign-in');
              window.location.reload(false);
            } else {
              setModalContent(response.message);
              setModalLink('');
              toggleModal();
            }
          }

        } else {
          dispatch(hideAppLoader());
          setModalContent("Debit card details are invalid. Please check and try again.");
          setModalLink('');
          toggleModal();
        }
      } else {
        dispatch(hideAppLoader());
        setModalContent(result.error.message);
        setModalLink('');
        toggleModal();
      }
    } else if (paymentType === "debitCard" || paymentType === "creditCard") {
      const card = elements.getElement(CardNumberElement);
      const result = await stripe.createToken(card, {
        currency: 'usd',
        name: cardName,
      }, stripeResponseHandler);
      if (result.token) {
        dispatch(hideAppLoader());
        if (type === "buyerSeller") {
          if (result.token.card.funding !== "debit" && result.token.card.funding !== "credit") {
            setModalContent("Card details not validated")
            setModalLink('');
            toggleModal();
          } else {
            callProfileApI()
          }

        } else {
          if (paymentType === "debitCard" && result.token.card.funding !== "debit") {
            setModalContent("Debit card details not validated.")
            setModalLink('');
            toggleModal();
          } else if (paymentType === "creditCard" && result.token.card.funding !== "credit") {
            setModalContent("Credit card details not validated.")
            setModalLink('');
            toggleModal();
          } else if (paymentType === "debitCard" && result.token.card.funding === "debit") {
            callProfileApI()
          } else if (paymentType === "creditCard" && result.token.card.funding === "credit") {
            callProfileApI()
          }
          else {
            dispatch(hideAppLoader());
            setModalContent(paymentType === "debitCard" ? "Debit card details are invalid. Please check and try again." : "Credit card details are invalid. Please check and try again.");
            setModalLink('');
            toggleModal();
          }
        }

      }
      if (result.error) {
        dispatch(hideAppLoader());
        setModalContent(result.error.message)
        setModalLink('');
        toggleModal();
        return false
      }
    }
    else {
      const getResponse = await dispatch(setupIntentGet(token));
      if (getResponse.status === "SUCCESS") {
        //Credit Card
        let client_secret = getResponse.payload
        const payload = await stripe
          .confirmCardSetup(client_secret, {
            payment_method: {
              card: elements.getElement(CardNumberElement),
              billing_details: {
                name: cardName,
              },
            },
          })
          .then(function (result) {
            if (result.error) {
              dispatch(hideAppLoader());
              setModalContent(result.error.message);
              setModalLink('');
              toggleModal();
            } else {
              paymentMethodCreateFun(result)
            }
          });
      } else {
        setModalContent(getResponse.message);
        setModalLink('');
        toggleModal();
      }
    }

  }
  const paymentMethodCreateFun = async (result) => {
    let response;
    let data = {
      forBuying: true,
      paymentMethodId: result.setupIntent.payment_method,
      name: cardName
    }
    if (paymentType === 'subscriptions') {
      response = await dispatch(subscriptionsCreate(data, token));
    } else {
      if (paymentType === 'subscriptionsPayment') {
        response = await dispatch(subscriptionsAddNew(data, token));
      } else {
        if (individual === "Individual") {
          response = await dispatch(paymentMethodProfileCreate(data, token));
        } else {
          response = await dispatch(paymentMethodCreate(data, token));
        }
      }
    }

    if (response?.status === "SUCCESS") {
      setAlertType('cardValidated')
      setModalContent("Card details added successfully.");
      setModalLink('');
      toggleModal();
    }
    else {
      if (response?.message === "Unauthorized (Invalid token)") {
        history.push('/sign-in');
        window.location.reload(false);
      } else {
        setModalContent(response?.message);
        setModalLink('');
        toggleModal();
      }
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }
    if (!cardName) {
      setModalContent("Please enter name on the card first.");
      setModalLink('');
      toggleModal();
    } else {
      callSubmit()
    }

  };
  const stripeResponseHandler = (status, response) => {
  }

  return (
    <div className='paymentWrapper '>
      {loaderVisible && <Spinner />}
      <div className='payment'>
        <div>
          <CardTypeSectionStripe>
            <form onSubmit={handleSubmit}>
              <label>
                {pageLanguageContents?.Arrow_Payment[18]?.SubName || 'Name on the Card'}
                <input
                  name='cardName'
                  className='stripeInput'
                  placeholder={pageLanguageContents?.Arrow_Payment[18]?.SubName}
                  value={cardName}
                  // onChange={(event) => {
                  //   const setValue = event.target.value.replace(/[^a-zA-Z\s&.,-]/g, '')
                  //   let firstLetterCap = setValue.charAt(0).toUpperCase() + setValue.slice(1)
                  //   setCardName(firstLetterCap);
                  // }}
                  onChange={(event) => {
                    const setValue = event.target.value;
                    const sanitizedValue = setValue.replace(/[^A-Za-z&,.\- ]/g, '');
                    const containsLetters = /[A-Za-z]/.test(sanitizedValue);

                    if (containsLetters) {
                      // Capitalize the first letter of each word
                      const words = sanitizedValue.split(/\s+/);
                      const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
                      const formattedValue = capitalizedWords.join(' ');
                      setCardName(formattedValue)
                    } else {
                      // If the input does not contain letters, set an empty string in the form field or display an error message
                      setCardName("")
                    }
                  }}
                />
              </label>
              <label>
                {pageLanguageContents?.Arrow_Payment[19]?.SubNumber}
                <CardNumberElement
                  options={options}
                  onReady={() => {
                  }}
                  onChange={(event) => {
                    // Switch brand logo
                    if (event.brand) {
                      setBrandIcon(event.brand);
                    }

                  }}
                  onBlur={() => {
                  }}
                  onFocus={() => {
                  }}
                />
                <span class="brand">
                  <i id={"brand-icon0"}></i>
                </span>
              </label>

              <label>
                {pageLanguageContents?.Arrow_Payment[20]?.SubDate}
                <CardExpiryElement
                  options={options}
                  onReady={() => {
                  }}
                  onChange={(event) => {
                  }}
                  onBlur={() => {
                  }}
                  onFocus={() => {
                  }}
                />
              </label>
              <label>
                {pageLanguageContents?.Arrow_Payment[21]?.SubCVV}
                <CardCvcElement
                  options={options}
                  onReady={() => {
                  }}
                  onChange={(event) => {
                  }}
                  onBlur={() => {
                  }}
                  onFocus={() => {
                  }}
                />

                <Tooltip
                  placement="top"
                  arrow
                  title={<img src={CvcIcon} alt="icon" />}
                  enterTouchDelay={0}
                >
                  <span className="i-icon">i</span>
                </Tooltip>
              </label>
              <div className={styles.footer}>
                <div className={styles.fieldGroup}>

                  <div className={styles.field}>
                    <button
                      type='submit'
                      className='app-green-button'
                      disabled={!stripe}>
                      {pageLanguageContents?.Arrow_Payment[22]?.Submit}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </CardTypeSectionStripe>
          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title={title}
            alertType={alertType}
            callBackAlert={(val) => {
              if (val === 'cardValidated') {
                callBackFetchApi()
                callBack()
                setModal(!modal)
                // callBackModal()
                profileAPI()
              }
              if (val === "buyerCardValidated") {
                callBackFetchApi()
                callBack()
              }

            }}
            content={modalContent}
            link={modalLink}
          />

          <Popup
            isOpen={yesNomodal}
            toggle={yesNoToggleModal}
            title=''
            onClickHander={(val) => {
            }}
            content={pageLanguageContents?.Arrow_Payment[23]?.Confirm_Registration}
            link='/'
          />
        </div>
      </div>
    </div>
  );
};

export default DebitForm;